import React, { useState } from "react";

const Accordion = ({
  children,
  title
}) => {
  const [isOpen, setIsOpen] = useState(true);

  function changeSelection() {
    setIsOpen(!isOpen);
  }

  return (
    <div className="accordion-item">
      <div className={`btn-accordion${isOpen ? " active" : ""}`} onClick={changeSelection}>
        <h4 className="text-gray-70 font-bold">{title}</h4>
        <div className="icons">
          <i className="icon icon-arrow-down-short"></i>
          <i className="icon icon-arrow-up-short"></i>
        </div>
      </div>
      {isOpen && <div className="content-accordion">{children}</div>}
    </div>
  );
};

export default Accordion;
